import { render, staticRenderFns } from "./TaxDeduction.vue?vue&type=template&id=aaaceffa&scoped=true"
import script from "./TaxDeduction.vue?vue&type=script&lang=js"
export * from "./TaxDeduction.vue?vue&type=script&lang=js"
import style0 from "./TaxDeduction.vue?vue&type=style&index=0&id=aaaceffa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaaceffa",
  null
  
)

export default component.exports